export enum KeyboardMap {
  ENTER = 'ENTER',
  ESCAPE = 'ESCAPE',
  TAB = 'TAB',
  SHIFT = 'SHIFT',
  PAGE_DOWN = 'PAGE_DOWN',
  PAGE_UP = 'PAGE_UP',
  ARROW_UP = 'ARROW_UP',
  ARROW_DOWN = 'ARROW_DOWN',
  ARROW_LEFT = 'ARROW_LEFT',
  ARROW_RIGHT = 'ARROW_RIGHT',
  HOME = 'HOME',
  END = 'END',
  OTHER = 'OTHER'
}

function getPressedKey(e: KeyboardEvent | React.KeyboardEvent): KeyboardMap {
  switch (e.key ? e.key.toLowerCase() : e.which) {
    case 'enter':
    case 13:
      return KeyboardMap.ENTER;
    case 'escape':
    case 27:
      return KeyboardMap.ESCAPE;
    case 'tab':
    case 9:
      return KeyboardMap.TAB;
    case 'shift':
    case 16:
      return KeyboardMap.SHIFT;
    case 'pageup':
    case 33:
      return KeyboardMap.PAGE_UP;
    case 'pagedown':
    case 34:
      return KeyboardMap.PAGE_DOWN;
    case 'arrowleft':
    case 37:
      return KeyboardMap.ARROW_LEFT;
    case 'arrowup':
    case 38:
      return KeyboardMap.ARROW_UP;
    case 'arrowright':
    case 39:
      return KeyboardMap.ARROW_RIGHT;
    case 'arrowdown':
    case 40:
      return KeyboardMap.ARROW_DOWN;
    case 'home':
    case 36:
      return KeyboardMap.HOME;
    case 'end':
    case 35:
      return KeyboardMap.END;
    default:
      return KeyboardMap.OTHER;
  }
}

export default getPressedKey;
